// extracted by mini-css-extract-plugin
module.exports = {"image-item":"SelectedWorks_image-item__2dopo","content-container":"SelectedWorks_content-container__3GB3g"};